export default __webpack_public_path__ + "static/home-specialty-disney-47f6a2628453c8957826da1969d49d78.jpg";